@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">POS Settings</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#Pos_Settings">POS Settings</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#Pos_Sales_Tax_Settings">POS Sales Tax and
                                Commission</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#Message_Settings">Message Settings</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <form [formGroup]="posSettingsForm" class="tab-pane fade show active" id="Pos_Settings">
                            <div class="p-4 container-fluid bg-white border rounded">
                                <div formGroupName="SalesTypesSettings">
                                    <div class="col-12 mb-2">
                                        <label class="form-label fw-semibold">Sale Types Settings</label>
                                    </div>
                                    <div class="row ms-1">
                                        <div class="col-6 col-md-4 col-lg-2 col-xl-1 d-flex align-items-center mb-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowRetail" id="retail">
                                                <label class="form-check-label" for="retail">Retail</label>
                                            </div>
                                        </div>

                                        <div class="col-6 col-md-4 col-lg-2 col-xl-1 d-flex align-items-center mb-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowWholeSale" id="wholesale">
                                                <label class="form-check-label" for="wholesale">Wholesale</label>
                                            </div>
                                        </div>

                                        <div class="col-6 col-md-4 col-lg-2 col-xl-1 d-flex align-items-center mb-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowShipped" id="online">
                                                <label class="form-check-label" for="online">Online</label>
                                            </div>
                                        </div>

                                        <div class="col-6 col-md-4 col-lg-2 col-xl-1 d-flex align-items-center mb-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowLayaway" id="layaway">
                                                <label class="form-check-label" for="layaway">Layaway</label>
                                            </div>
                                        </div>

                                        <div class="col-6 col-md-4 col-lg-2 col-xl-1 d-flex align-items-center mb-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowPending" id="pending">
                                                <label class="form-check-label" for="pending">Pending</label>
                                            </div>
                                        </div>

                                        <div class="col-6 col-md-4 col-lg-2 col-xl-1 d-flex align-items-center mb-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowReturn" id="return">
                                                <label class="form-check-label" for="return">Return</label>
                                            </div>
                                        </div>

                                        <div class="col-6 col-md-4 col-lg-2 col-xl-1 d-flex align-items-center mb-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowVoid" id="void">
                                                <label class="form-check-label" for="void">Void</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3 align-items-center">
                                        <div class="col-auto">
                                            <label for="defaultSaleType" class="form-label mb-0">Default Sale Type
                                                Selected</label>
                                        </div>
                                        <div class="col-3">
                                            <select class="form-select" id="defaultSaleType"
                                                formControlName="DefaultSaleType">
                                                <option value="" disabled>--Select--</option>

                                                @if (posSettingsForm.get('SalesTypesSettings.AllowRetail')?.value) {
                                                <option value="1">Retail</option>
                                                }
                                                @if (posSettingsForm.get('SalesTypesSettings.AllowWholeSale')?.value) {
                                                <option value="2">Wholesale</option>
                                                }
                                                @if (posSettingsForm.get('SalesTypesSettings.AllowShipped')?.value) {
                                                <option value="3">Online</option>
                                                }
                                                @if (posSettingsForm.get('SalesTypesSettings.AllowLayaway')?.value) {
                                                <option value="4">Layaway</option>
                                                }
                                                @if (posSettingsForm.get('SalesTypesSettings.AllowPending')?.value) {
                                                <option value="5">Pending</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row g-4 mt-2">
                                        <div class="col-md-6 col-lg-3 me-4">
                                            <label for="defaultCustomerRetail" class="form-label">
                                                Set Default Customer ID for Retail Sale
                                            </label>
                                            <div class="input-group">
                                                <input type="text" id="defaultCustomerRetail" class="form-control"
                                                    formControlName="MarketCustIdForRetail"
                                                    (input)="allowOnlyDigits($event, 5, 'SalesTypesSettings.MarketCustIdForRetail')">
                                                <button class="btn btnAS-icon" type="button"
                                                    (click)="openCustomerModal('retail')">
                                                    <i class="bi bi-search"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-lg-3 d-flex align-items-center me-4">
                                            <div class="form-check mt-4">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="CustIdReqPendingSale"
                                                    id="customerMandatoryPending">
                                                <label class="form-check-label" for="customerMandatoryPending">
                                                    Make Customer ID Mandatory for Pending Sale
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-lg-3 me-4"
                                            *ngIf="!posSettingsForm.get('SalesTypesSettings.CustIdReqPendingSale')?.value">
                                            <label for="defaultCustomerPending" class="form-label">
                                                Set Default Customer ID for Pending Sale
                                            </label>
                                            <div class="input-group">
                                                <input type="text" id="defaultCustomerPending" class="form-control"
                                                    formControlName="MarketCustIdForPendingSale"
                                                    (input)="allowOnlyDigits($event, 5, 'SalesTypesSettings.MarketCustIdForPendingSale')">
                                                <button class="btn btnAS-icon" type="button"
                                                    (click)="openCustomerModal('pending')">
                                                    <i class="bi bi-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal fade" id="customerModal" #customerModal tabindex="-1"
                                    aria-labelledby="customerModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-xl modal-dialog-centered">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="customerModalLabel">
                                                    Customer Search</h5>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                    aria-label="Close"></button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div>
                                                            <div
                                                                class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3">
                                                                <app-pos-customer-search [customerSearch]="true"
                                                                    (customerData)="CustomerInfo($event)">
                                                                </app-pos-customer-search>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-secondary"
                                                    data-bs-dismiss="modal">Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div formGroupName="OtherSettings">
                                    <div class="row">
                                        <div class="col-12 mb-2">
                                            <label class="form-label fw-semibold">Other Settings</label>
                                        </div>

                                        <div class="col-12">
                                            <div class="row">
                                                <!-- Row 1 -->
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" formControlName="TrackSalesbyPerson"
                                                            class="form-check-input" id="chkTrackSales">
                                                        <label class="form-label mb-0 ms-2" for="chkTrackSales"
                                                            style="margin-top: 1px;">Track Sales by Sales
                                                            Person</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkUserwiseDayend"
                                                            formControlName="UserwiseDayend" class="form-check-input">
                                                        <label for="chkUserwiseDayend" class="form-label mb-0 ms-2"
                                                            style="margin-top: 1px">Terminal Userwise Day
                                                            End</label>
                                                    </div>
                                                </div>
                                                <!-- Row 2 -->
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkPosbyVendor"
                                                            formControlName="PosbyVendor"
                                                            class="form-check-input orange-check" checked>
                                                        <label class="form-label mb-0 ms-2" for="chkPosbyVendor">
                                                            {{'POS Transaction by Vendor' | wordReplace}}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkUsePoleDisplay"
                                                            formControlName="UsePoleDisplay"
                                                            class="form-check-input orange-check" checked>
                                                        <label class="form-label mb-0 ms-2" for="chkUsePoleDisplay"
                                                            style="margin-top: 1px">Use Pole Display in
                                                            POS</label>
                                                    </div>
                                                </div>
                                                <!-- Row 3 -->
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkAllowAutoConsignmentId"
                                                            formControlName="AllowAutoConsignmentId"
                                                            class="form-check-input">
                                                        <label class="form-label mb-0 ms-2"
                                                            for="chkAllowAutoConsignmentId"
                                                            style="margin-top: 1px;">Allow Auto Consignment
                                                            ID</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2" hidden="true">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkTouchScreenPos"
                                                            formControlName="TouchScreenPos" class="form-check-input">
                                                        <label class="form-label mb-0 ms-2" for="chkTouchScreenPos"
                                                            style="margin-top: 1px">Use Touch Screen Interface
                                                            for
                                                            POS</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkIssueGc" formControlName="IssueGc"
                                                            class="form-check-input orange-check" checked>
                                                        <label class="form-label mb-0 ms-2" for="chkIssueGc">Enable GC
                                                            for Return / Void
                                                            Sale</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkQbmappingNew"
                                                            formControlName="QbmappingNew"
                                                            class="form-check-input orange-check">
                                                        <label class="form-label mb-0 ms-2" for="chkQbmappingNew"
                                                            style="margin-top: 1px">Use QB for Check Writing
                                                            Only</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkNegativePosPayoutAmtAdjust"
                                                            formControlName="NegativePosPayoutAmtAdjust"
                                                            class="form-check-input">
                                                        <label class="form-label mb-0 ms-2"
                                                            for="chkNegativePosPayoutAmtAdjust"
                                                            style="margin-top: 1px">Allow Negative Sales in
                                                            POS</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkUseQboforCheckPrinting"
                                                            formControlName="UseQboforCheckPrinting"
                                                            class="form-check-input orange-check">
                                                        <label class="form-label mb-0 ms-2"
                                                            for="chkUseQboforCheckPrinting" style="margin-top: 1px">Use
                                                            QBO for Check Printing
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkAllowVendorDiscount"
                                                            formControlName="AllowVendorDiscount"
                                                            class="form-check-input">
                                                        <label class="form-label mb-0 ms-2" for="chkAllowVendorDiscount"
                                                            style="margin-top: 1px">Allow Apply Discount in
                                                            POS</label>
                                                    </div>
                                                </div>
                                                @if(vermontAntiquesMallChanges){
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkIncludeVendorAddressInIif"
                                                            formControlName="IncludeVendorAddressInIif"
                                                            class="form-check-input orange-check">
                                                        <label class="form-label mb-0 ms-2"
                                                            for="chkIncludeVendorAddressInIif"
                                                            style="margin-top: 1px">Include {{'Vendor' | wordReplace}}
                                                            Address and Pincode in IIF File
                                                        </label>
                                                    </div>
                                                </div>
                                                }
                                                <div class="col-md-6 mb-2">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkAllowPennyRounding"
                                                            formControlName="IsPOSCashRounding"
                                                            class="form-check-input">
                                                        <label class="form-label mb-0 ms-2" for="chkAllowPennyRounding"
                                                            style="margin-top: 1px">Enable Penny Rounding for POS Cash
                                                            Payments</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-2" style="display: none;">
                                                    <div class="d-inline justify-content-between align-items-center">
                                                        <input type="checkbox" id="chkChgPayModeInVoid"
                                                            formControlName="ChgPayModeInVoid" class="form-check-input">
                                                        <label class="form-label mb-0 ms-2" for="chkChgPayModeInVoid"
                                                            style="margin-top: 1px">Allow changing Payment Mode in
                                                            Void</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="col-md-6 mb-2">
                                            <div class="d-inline justify-content-between align-items-center">
                                                <input type="checkbox" id="chkUseBarcodeScanner"
                                                    formControlName="UseBarcodeScanner" class="form-check-input">
                                                <label class="form-label mb-0 ms-2" for="chkUseBarcodeScanner"
                                                    style="margin-top: 1px;">Use Barcode Scanner in POS</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-2">
                                            <div class="d-inline justify-content-between align-items-center">
                                                <input type="checkbox" id="chkUseNoScannerDefault"
                                                    formControlName="UseNoScannerDefault" class="form-check-input">
                                                <label class="form-label mb-0 ms-2" for="chkUseNoScannerDefault"
                                                    style="margin-top: 1px">Default Check "No Scanner"</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-3">
                                            <div class="row align-items-center">
                                                <div class="col-auto">
                                                    <label for="defaultBarcodeTemplate" class="form-label mb-0 mt-1">
                                                        Default Barcode Template
                                                    </label>
                                                </div>
                                                <div class="col-md-6">
                                                    <select class="form-select" id="defaultBarcodeTemplate"
                                                        formControlName="DefaultBarcodeTemplate">
                                                        <option [value]="null" disabled>
                                                            -- Select Template --
                                                        </option>
                                                        <option *ngFor="let template of barcodeTemplates"
                                                            [value]="template.TemplateName">
                                                            {{ template.TemplateName }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-3">
                                            <div class="d-inline-flex align-items-center mt-1">
                                                <input type="checkbox" id="chkAutomaticInventoryStockID"
                                                    formControlName="AutomaticInventoryStockID"
                                                    class="form-check-input">

                                                <label class="form-label mb-0 ms-2" for="chkAutomaticInventoryStockID">
                                                    Automatic Inventory Stock ID
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row align-items-center">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="row align-items-center">
                                                <div class="col-auto">
                                                    <label class="form-label mt-1">
                                                        User Defined Term for Traveler Check
                                                    </label>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <input type="text" formControlName="TravelerCheckTerm"
                                                        id="travelerCheck" class="form-control form-control-sm mt-1"
                                                        maxlength="50" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-check mt-1">
                                                <input class="form-check-input" type="checkbox"
                                                    id="makeTravelerNoOptional"
                                                    formControlName="MakeTravelerNoOptional" />
                                                <label class="form-check-label" for="makeTravelerNoOptional">
                                                    Make Traveler Check # optional
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-center mt-2">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="d-flex align-items-center gap-4">
                                                <label class="form-label mt-1 text-nowrap"
                                                    for="defaultVendorIdChangeReason">
                                                    Default Reason for {{'Vendor ID' | wordReplace}} Change
                                                </label>
                                                <input type="text" formControlName="DefaultVendorIdChangeReason"
                                                    id="defaultVendorIdChangeReason"
                                                    class="form-control form-control-sm mt-1 flex-grow-1"
                                                    maxlength="150" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-center g-3 mt-2">
                                        <div class="col-auto">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="DeletePendingCustomer"
                                                    id="deletePendingCustomer" />
                                                <label class="form-check-label" for="deletePendingCustomer">
                                                    Delete Pending Sale {{'Customer' | wordReplace }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="UserSalesToolbar" id="displaySalesStatusBar"
                                                    checked />
                                                <label class="form-check-label" for="displaySalesStatusBar">
                                                    Display User Sales in Status Bar
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row mb-3 align-items-center">
                                        <div class="row">
                                            <div class="col-md-12 col-lg-6 text-start mt-2">
                                                <div class="row mb-2">
                                                    <div class="col-md-6 col-lg-4">
                                                        <label class="form-label mb-0 mt-1">Opening Cash Amount</label>
                                                    </div>
                                                    <div class="col-md-6 col-lg-4">
                                                        <input type="text" formControlName="OpeningCashAmount"
                                                            class="form-control form-control-sm text-end"
                                                            appCurrencyFormatter value="$0.00" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-6 text-start mt-2">
                                                <div class="row mb-2">
                                                    <div class="col-md-12">
                                                        <div class="form-check mt-1">
                                                            <input class="form-check-input" type="checkbox"
                                                                id="excludeOpenCash"
                                                                formControlName="ExcludeOpenCashAmtFromDayEnd" />
                                                            <label class="form-check-label" for="excludeOpenCash">
                                                                Exclude Opening Cash Drawer Amount from Day End
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-6 text-start mt-2">
                                                <div class="row mb-2">
                                                    <div class="col-md-6 col-lg-4">
                                                        <label class="form-label mb-0 mt-1">Gift Certificates Max
                                                            Days</label>
                                                    </div>
                                                    <div class="col-md-6 col-lg-4">
                                                        <input type="text" formControlName="GcmaxDays"
                                                            class="form-control form-control-sm"
                                                            (input)="allowOnlyDigits($event, 4, 'OtherSettings.GcmaxDays')" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-6 text-start mt-2">
                                                <div class="row mb-2">
                                                    <div class="col-md-6 col-lg-4">
                                                        <label class="form-label mb-0 mt-1">Gift Certificate Sale
                                                            Term</label>
                                                    </div>
                                                    <div class="col-md-6 col-lg-4">
                                                        <input type="text" formControlName="GcSaleTerm"
                                                            class="form-control form-control-sm" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 col-lg-6 text-start mt-2">
                                                <div class="row mb-2">
                                                    <div class="col-md-6 col-lg-4">
                                                        <label class="form-label mb-0">{{'Vendor ID for Gift
                                                            Certificate' |
                                                            wordReplace}}</label>
                                                    </div>
                                                    <div class="col-10 col-md-4 col-lg-3">
                                                        <input type="text" formControlName="GcMarketVendorId"
                                                            class="form-control form-control-sm" maxlength="10"
                                                            (keydown)="allowOnlyAlphanumeric($event)" />
                                                    </div>
                                                    <div class="col-2 col-md-2 col-lg-3">
                                                        <button type="button" class="btn btn-dark-custom btn-sm"
                                                            data-bs-toggle="modal" data-bs-target="#vendorSearchModal"
                                                            (click)="setVendorContext('giftCertificate')">
                                                            <img src="./assets/images/search.svg" class="img-fluid" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-6 text-start mt-2">
                                                <div class="row mb-2">
                                                    <div class="col-md-6 col-lg-4">
                                                        <label class="form-label mb-0">{{'Booth Number for Gift
                                                            Certificate' | wordReplace}}</label>
                                                    </div>
                                                    <div class="col-md-6 col-lg-4">
                                                        <input type="text" formControlName="GcBoothNumber"
                                                            class="form-control form-control-sm" maxlength="10"
                                                            (keydown)="allowOnlyAlphanumeric($event)" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="col-12 mb-2">
                                        <label class="form-label fw-semibold">Bag Settings</label>
                                    </div>
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-12 mb-2">
                                            <div class="form-check mt-1">
                                                <input class="form-check-input" type="checkbox" id="chkEnableBag"
                                                    formControlName="EnableBag" />
                                                <label class="form-check-label" for="chkEnableBag">
                                                    Enable Bag
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6 text-start mt-2">
                                            <div class="row mb-2">
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label mb-0">{{'Bag Vendor' |
                                                        wordReplace}}</label>
                                                </div>
                                                <div class="col-10 col-md-4 col-lg-3">
                                                    <input type="text" formControlName="BagMarketVendorId"
                                                        class="form-control form-control-sm" maxlength="10"
                                                        (keydown)="allowOnlyAlphanumeric($event)"
                                                        (blur)="loadBagBoothOptions()" />
                                                </div>
                                                <div class="col-2 col-md-2 col-lg-3">
                                                    <button type="button" class="btn btn-dark-custom btn-sm"
                                                        data-bs-toggle="modal" data-bs-target="#vendorSearchModal"
                                                        (click)="setVendorContext('bag')">
                                                        <img src="./assets/images/search.svg" class="img-fluid" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6 text-start mt-2">
                                            <div class="row mb-2">
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label mb-0 mt-1">Booth Number for Bag</label>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <input type="text" formControlName="BagBoothNumber"
                                                        class="form-control form-control-sm" maxlength="10"
                                                        list="bagBoothOptionList"
                                                        (keydown)="allowOnlyAlphanumeric($event)" />
                                                    <datalist id="bagBoothOptionList">
                                                        <option *ngFor="let booth of bagBoothOptions" [value]="booth">
                                                        </option>
                                                    </datalist>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6 text-start mt-2">
                                            <div class="row mb-2">
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label mb-0 mt-1">Bag Price</label>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <input type="text" formControlName="BagPrice"
                                                        class="form-control form-control-sm text-end"
                                                        appCurrencyFormatter value="$0.00" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mb-2">
                                            <div class="form-check mt-1">
                                                <input class="form-check-input" type="checkbox" id="chkBagTaxable"
                                                    formControlName="BagTaxable" />
                                                <label class="form-check-label" for="chkBagTaxable">
                                                    Bag Taxable
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="col-12 mb-2">
                                    <label class="form-label fw-semibold">Discount Warnings</label>
                                </div>
                                <div formGroupName="DiscountSettings">
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    id="enableDiscountWarnings"
                                                    formControlName="EnableDiscountWarnings" />
                                                <label class="form-check-label" for="enableDiscountWarnings">
                                                    Enable Discount Warnings
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-4">
                                        <div class="col-md-6 d-flex gap-4">
                                            <div class="form-check">
                                                <input class="form-check-input border-warning" type="radio"
                                                    id="radio100"
                                                    [checked]="posSettingsForm.get('DiscountSettings.Warnon100PercentDiscount')?.value"
                                                    [disabled]="!posSettingsForm.get('DiscountSettings.EnableDiscountWarnings')?.value"
                                                    (change)="onDiscountRadioChange('100')" />
                                                <label class="form-check-label" for="radio100">
                                                    Warn on 100% Discount
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input border-warning" type="radio"
                                                    id="radioAny"
                                                    [checked]="posSettingsForm.get('DiscountSettings.WarnonAnyDiscount')?.value"
                                                    [disabled]="!posSettingsForm.get('DiscountSettings.EnableDiscountWarnings')?.value"
                                                    (change)="onDiscountRadioChange('any')" />
                                                <label class="form-check-label" for="radioAny">
                                                    Warn on any Discount
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="col-12 mb-3">
                                        <label class="form-label fw-semibold">Universal Discount Settings</label>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="EnableUniversalDiscount" id="universalDiscount" />
                                                <label class="form-check-label" for="universalDiscount">
                                                    Enable Universal Discount
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-3 text-left mt-2">
                                                <label>From Date</label>
                                                <ejs-datepicker class="form-control p-0" formControlName="Udfromdate"
                                                    [min]="today" (change)="onStartDateChange($event)"></ejs-datepicker>
                                            </div>
                                            <div class="col-md-6 col-lg-3 text-left mt-2">
                                                <label>To Date</label>
                                                <ejs-datepicker class="form-control p-0" formControlName="Udtodate"
                                                    [min]="minExpiryDate"></ejs-datepicker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 col-lg-3 text-left mt-2">
                                                <label>From Time</label>
                                                <ejs-timepicker class="form-control p-0"
                                                    formControlName="UdfromTime"></ejs-timepicker>
                                            </div>
                                            <div class="col-md-6 col-lg-3 text-left mt-2">
                                                <label>To Time</label>
                                                <ejs-timepicker class="form-control p-0"
                                                    formControlName="UdtoTime"></ejs-timepicker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-4">
                                        <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-3">
                                            <div class="row">
                                                <div class="col-md-auto col-lg-4">
                                                    <label for="discountType" class="form-label mb-0 mt-1">Discount
                                                        Type</label>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <select class="form-select form-select-sm" formControlName="Udtype">
                                                        <option value="1">Amount ($)</option>
                                                        <option value="2">Percentage (%)</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-3">
                                            <div class="row">
                                                <div class="col-auto">
                                                    <label class="form-label mb-0 mt-1" for="discountValue">Discount
                                                        Value</label>
                                                </div>
                                                <div class="col-4">
                                                    <ng-container
                                                        [ngSwitch]="getFormatterType('DiscountSettings.Udtype')">
                                                        <input *ngSwitchCase="'currency'" type="text"
                                                            formControlName="Udvalue"
                                                            class="form-control form-control-sm" appCurrencyFormatter />

                                                        <input *ngSwitchCase="'percentage'" type="text"
                                                            formControlName="Udvalue"
                                                            class="form-control form-control-sm" appPercentageFormatter
                                                            [maxPercentage]="100" />
                                                        <input *ngSwitchCase="'none'" type="text"
                                                            formControlName="Udvalue"
                                                            class="form-control form-control-sm" />
                                                    </ng-container>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="ApplyVenDiscountaboveUd"
                                                    id="enableVendorDiscount" />
                                                <label class="form-check-label" for="enableVendorDiscount">
                                                    {{'Apply Vendor Discount above Universal Discount' | wordReplace}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="col-12 mb-3">
                                        <label class="form-label fw-semibold">Store Discount Settings</label>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="EnableStoreDiscount" id="storeDiscount" />
                                                <label class="form-check-label" for="storeDiscount">
                                                    Enable Store Discount
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-3">
                                            <div class="row">
                                                <div class="col-md-6 col-lg-3">
                                                    <label for="vendorId" class="form-label mb-0 mt-1">
                                                        {{'Vendor ID'| wordReplace}}
                                                    </label>
                                                </div>
                                                <div class="col-10 col-md-4 col-lg-5">
                                                    <input type="text" id="vendorId" formControlName="MarketVendorId"
                                                        class="form-control form-control-sm" maxlength="10"
                                                        (keydown)="allowOnlyAlphanumeric($event)" />
                                                </div>
                                                <div class="col-2 col-md-2 col-lg-3">
                                                    <button type="button" class="btn btn-dark-custom btn-sm"
                                                        data-bs-toggle="modal" data-bs-target="#vendorSearchModal"
                                                        (click)="setVendorContext('storeDiscount')"
                                                        [disabled]="!posSettingsForm.get('DiscountSettings.EnableStoreDiscount')?.value">
                                                        <img src="./assets/images/search.svg" class="img-fluid" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Modal with Vendor Search Component -->
                                    <div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1"
                                        aria-labelledby="vendorSearchLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-lg modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title" id="vendorSearchLabel">
                                                        {{'Select Vendor' | wordReplace}}
                                                    </h5>
                                                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                        aria-label="Close"></button>
                                                </div>
                                                <div class="modal-body">
                                                    <app-vendor-search [isVendorPopUp]="true"
                                                        [VendorFilterOption]="VendorFilterOption"
                                                        (vendorSearchRoute)="onVendorSelected($event)">
                                                    </app-vendor-search>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-4">
                                        <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-3">
                                            <div class="row">
                                                <div class="col-md-6 col-lg-3">
                                                    <label for="storeDiscountType" class="form-label mb-0 mt-1">Discount
                                                        Type</label>
                                                </div>
                                                <div class="col-md-6 col-lg-6">
                                                    <select class="form-select form-select-sm"
                                                        formControlName="StoreDicountType">
                                                        <option value="1">Amount ($)</option>
                                                        <option value="2">Percentage (%)</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-3">
                                            <div class="row">
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label mb-0 mt-1" for="discountValue">Discount
                                                        Value</label>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <ng-container
                                                        [ngSwitch]="getFormatterType('DiscountSettings.StoreDicountType')">
                                                        <input *ngSwitchCase="'currency'" type="text"
                                                            formControlName="StoreDiscountValue"
                                                            class="form-control form-control-sm" appCurrencyFormatter />

                                                        <input *ngSwitchCase="'percentage'" type="text"
                                                            formControlName="StoreDiscountValue"
                                                            class="form-control form-control-sm" appPercentageFormatter
                                                            [maxPercentage]="100" />
                                                        <input *ngSwitchCase="'none'" type="text"
                                                            formControlName="StoreDiscountValue"
                                                            class="form-control form-control-sm" />
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div formGroupName="LayawaySettings">
                                    <div class="row">
                                        <div class="col-12 text-start">
                                            <label class="fw-semibold mb-2">Layaway Settings</label>
                                            <div class="row">
                                                <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-2">
                                                    <div class="row mb-3">
                                                        <div class="col-md-6 col-lg-4">
                                                            <label class="form-label mb-0">Down Payment</label>
                                                        </div>
                                                        <div class="col-md-6 col-lg-4">
                                                            <input type="text" formControlName="DownPaymentPercent"
                                                                appPercentageFormatter
                                                                class="form-control form-control-sm" value="0.00%" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-2">
                                                    <div class="row mb-3">
                                                        <div class="col-md-6 col-lg-4">
                                                            <label class="form-label mb-0">Number of Days</label>
                                                        </div>
                                                        <div class="col-md-6 col-lg-4">
                                                            <input type="text" formControlName="LayawayNumberOfDays"
                                                                class="form-control form-control-sm"
                                                                (input)="allowOnlyDigits($event, 3, 'LayawaySettings.LayawayNumberOfDays')" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-6 text-start mt-2">
                                                    <div class="row mb-3">
                                                        <div class="col-md-6 col-lg-4">
                                                            <label class="form-label mb-0">Number of
                                                                Installments</label>
                                                        </div>
                                                        <div class="col-md-6 col-lg-4">
                                                            <input type="text" formControlName="NumberOfInstalments"
                                                                class="form-control form-control-sm"
                                                                (input)="allowOnlyDigits($event, 1, 'LayawaySettings.NumberOfInstalments')" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-12">
                                                    <label class="form-label">Message</label>
                                                </div>
                                                <div class="col-md-12">
                                                    <textarea formControlName="LayawayMessage"
                                                        class="form-control form-control-sm" rows="4"
                                                        maxlength="500"></textarea>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-6">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            formControlName="InclLwayInPayOut" id="excludeLayaway" />
                                                        <label class="form-check-label" for="excludeLayaway">
                                                            Exclude Open Layaway Sales in Payout
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <form [formGroup]="taxSettingsForm" class="tab-pane fade" id="Pos_Sales_Tax_Settings">
                            <div class="container-fluid p-4 bg-white border rounded">

                                <h6 class="fw-semibold mb-3">POS Tax Settings</h6>
                                <div formGroupName="TaxSettings">
                                    <div class="row mb-4">
                                        <div class="col-md-12 col-lg-6 d-flex gap-4">
                                            <div class="form-check">
                                                <input class="form-check-input border-warning" type="radio"
                                                    formControlName="ApplyPostaxItemwise" name="taxCalculation"
                                                    id="itemwiseTax" [value]="true" />
                                                <label class="form-check-label" for="itemwiseTax">
                                                    Apply Itemwise Tax Calculation
                                                </label>
                                            </div>

                                            <div class="form-check">
                                                <input class="form-check-input border-warning" type="radio"
                                                    formControlName="ApplyPostaxItemwise" name="taxCalculation"
                                                    id="orderwiseTax" [value]="false" />
                                                <label class="form-check-label" for="orderwiseTax">
                                                    Apply Orderwise Tax Calculation
                                                </label>
                                            </div>
                                            <hr />
                                        </div>
                                    </div>
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-9">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="ApplyPossalesTax" id="applySalesTax" />
                                                <label class="form-check-label" for="applySalesTax">Apply Sales
                                                    Tax</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-2">
                                            <input type="text" formControlName="PossalesTaxPercent"
                                                class="form-control form-control-sm" appPercentageFormatter
                                                value="0.00%" />

                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-9">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="ApplyOnPossalesTax" id="applySalesTaxSecond" />
                                                <label class="form-check-label" for="applySalesTaxSecond">Apply
                                                    Sales
                                                    Tax on
                                                    Second level Tax</label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-9">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="ApplyPossecondLevelTax" id="applySecondLevelTax" />
                                                <label class="form-check-label" for="applySecondLevelTax">Apply
                                                    Second
                                                    level
                                                    Tax</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-2">
                                            <input type="text" formControlName="PossecondLevelTaxPercent"
                                                class="form-control form-control-sm" appPercentageFormatter
                                                value="0.00%" />

                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-9">
                                            <label class="form-label">Second level Tax Name</label>
                                        </div>
                                        <div class="col-md-6 col-lg-2">
                                            <input type="text" formControlName="PossecondLevelTaxName"
                                                class="form-control form-control-sm" maxlength="50" />
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <h6 class="fw-semibold mb-3">Commissions</h6>
                                <div formGroupName="Commission">
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-9">
                                            <label class="form-label mb-0">Flat Commission (%)</label>
                                        </div>
                                        <div class="col-md-6 col-lg-2">
                                            <input type="text" formControlName="FlatCommission"
                                                class="form-control form-control-sm bg-light" appPercentageFormatter
                                                value="0.00%" />

                                        </div>
                                    </div>
                                    <div class="row mb-2 align-items-center">
                                        <div class="col-md-6 col-lg-9">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="ApplyCommission" id="enableDropVendorCommission" />
                                                <label class="form-check-label" for="enableDropVendorCommission">
                                                    {{'Vendor'| wordReplace}}wise Consignment Commission
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-2">
                                            <input type="text" formControlName="DealerConCommPercent"
                                                class="form-control form-control-sm" appPercentageFormatter
                                                value="0.00%" />
                                        </div>
                                    </div>
                                    <div class="row mb-2 align-items-center" hidden="true">
                                        <div class="col-md-4">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowDropppingCommission" id="chkEnableDropping" />
                                                <label class="form-check-label" for="chkEnableDropping">
                                                    {{'Enable Dropping of Vendor Commission' | wordReplace}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="ShowCommissiononPos"
                                                    id="showCommissionPercentage" />
                                                <label class="form-check-label" for="showCommissionPercentage">
                                                    Show Commission % in POS
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowCommissionOverride"
                                                    id="allowCommissionOverride" />
                                                <label class="form-check-label" for="allowCommissionOverride">
                                                    Allow User to Override Default Commission
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <h6 class="fw-semibold mb-3">POS Sales</h6>
                                <div formGroupName="POSSales">
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-9">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="AllowPossalesWithOutBooking"
                                                    id="allowPossalesWithOutBooking" />
                                                <label class="form-check-label" for="allowPossalesWithOutBooking">Allow
                                                    POS Sales Without Booking</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3 align-items-center" hidden="true">
                                        <div class="col-md-6 col-lg-9">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="ConfirmDiscountinPos" id="confirmDiscountinPos" />
                                                <label class="form-check-label" for="confirmDiscountinPos">Confirm
                                                    Discount while adding the Item</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-4 mt-2">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="FillDefaultIteminPos" id="fillDefaultIteminPos" />
                                                <label class="form-check-label" for="fillDefaultIteminPos">
                                                    Set Default Item in POS
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-8 col-lg-2 text-start mt-2">
                                            <label class="form-label mb-0" for="defaultItemName">
                                                Default Item Description
                                            </label>
                                        </div>
                                        <div class="col-md-2 mt-md-0 mt-lg-2">
                                            <input type="text" id="defaultItemName" formControlName="DefaultItemName"
                                                class="form-control form-control-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="EnableOtherChargeinPos"
                                                    id="enableOtherChargeinPos" />
                                                <label class="form-check-label" for="enableOtherChargeinPos">
                                                    Enable Other Charge in POS
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-8 col-lg-2 text-left mt-2">
                                            <label class="form-label mb-0" for="posotherChargeName">
                                                POS Other Charge Name
                                            </label>
                                        </div>
                                        <div class="col-md-2 mt-md-0 mt-lg-2">
                                            <input type="text" id="posotherChargeName"
                                                formControlName="PosotherChargeName"
                                                class="form-control form-control-sm" maxlength="50" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <form [formGroup]="messageSettingsForm" class="tab-pane fade" id="Message_Settings">
                            <div class="container-fluid p-4 bg-white border rounded">
                                <h6 class="fw-semibold">POS Receipts and Settlement Report Messages</h6>

                                <div class="mb-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label for="returnPolicy" class="form-label mb-1">Return Policy</label>
                                        <div class="form-check d-flex align-items-center">
                                            <input type="checkbox" formControlName="PrintReturnPolicyonReceipt"
                                                class="form-check-input me-1" id="returnPolicyCheck">
                                            <label class="form-check-label small" for="returnPolicyCheck">Print on
                                                Receipt</label>
                                        </div>
                                    </div>
                                    <textarea class="form-control" id="returnPolicy" formControlName="ReturnPolicy"
                                        rows="3" maxlength="250"></textarea>
                                </div>
                                <div class="mb-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label for="workingHours" class="form-label mb-1">Working Hours</label>
                                        <div class="form-check d-flex align-items-center">
                                            <input type="checkbox" formControlName="PrintWorkingHoursonReceipt"
                                                class="form-check-input me-1" id="workingHoursCheck">
                                            <label class="form-check-label small" for="workingHoursCheck">Print on
                                                Receipt</label>
                                        </div>
                                    </div>
                                    <textarea class="form-control" id="workingHours" formControlName="WorkingHours"
                                        rows="3" maxlength="250"></textarea>
                                </div>
                                <div class="mb-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label for="advertisement" class="form-label mb-1">Advertisement</label>
                                        <div class="form-check d-flex align-items-center">
                                            <input type="checkbox" formControlName="AdvertisementonReceipt"
                                                class="form-check-input me-1" id="advertisementCheck">
                                            <label class="form-check-label small" for="advertisementCheck">Print on
                                                Receipt</label>
                                        </div>
                                    </div>
                                    <textarea class="form-control" id="advertisement" formControlName="Advertisement"
                                        rows="3" maxlength="250"></textarea>
                                </div>
                                <div class="mb-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label for="comments" class="form-label mb-1">Comments</label>
                                        <div class="form-check d-flex align-items-center">
                                            <input type="checkbox" formControlName="CommentsonReceipt"
                                                class="form-check-input me-1" id="commentsCheck">
                                            <label class="form-check-label small" for="commentsCheck">Print on
                                                Receipt</label>
                                        </div>
                                    </div>
                                    <textarea class="form-control" id="comments" formControlName="Comments" rows="3"
                                        maxlength="250"></textarea>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-lg-4 text-start mt-3">
                                        <div class="form-check">
                                            <input type="checkbox" formControlName="UseFbinPos" id="chkFacebookID"
                                                class="form-check-input">
                                            <label class="form-check-label" for="chkFacebookID">Print Facebook ID on
                                                POS
                                                Receipt</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 text-start mt-3">
                                        <div class="form-check">
                                            <input type="checkbox" formControlName="UseTwinPos" id="chkTwitterID"
                                                class="form-check-input">
                                            <label class="form-check-label" for="chkTwitterID">Print Twitter ID on
                                                POS
                                                Receipt</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3 mt-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <label for="Settlements" class="form-label mb-1">Settlement Report
                                            Message</label>
                                        <div class="form-check d-flex align-items-center">
                                            <input type="checkbox" formControlName="PrintSettlementMessage"
                                                class="form-check-input me-1" id="ReportMessage">
                                            <label class="form-check-label small" for="ReportMessage">Print on
                                                Settlement Report</label>
                                        </div>
                                    </div>
                                    <textarea class="form-control" id="comments" formControlName="SettlementMessage"
                                        rows="3" maxlength="250"></textarea>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-md-end my-2">
                    <ejs-tooltip id="tooltipbtnSave" target="#targetSave" position="TopCenter" openMode="Auto"
                        windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                        <button id="targetSave" class="btn btnAS" type="button" (click)="saveSettings()"
                            [userPermissionHandler]="editPermissionHandlerData">
                            Save
                        </button>
                    </ejs-tooltip>
                    <button class="btn btn-orange ms-1" type="button" (click)="cancelChanges()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>